import angular from 'angular';
import _ from 'lodash';

// eslint-disable-next-line no-useless-escape
export const EMAIL_REGEX_VALIDATOR = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export function UtilsService() {
    const isNumber = (value) => {
        const number = value - 0;

        return !isNaN(number) && angular.isNumber(number);
    };

    const isWebsite = (website) => {
        const site = { type: '', ...website };
        const siteType = (site.type || '').toLowerCase();
        const siteTypes = ['website', 'url', 'blog', 'indeed', 'youtube', 'xing', 'myspace'];

        return siteTypes.includes(siteType);
    };

    const isLocationString = (value) => {
        const locationDelimiter = ',';
        return (!!value
            && angular.isString(value)
            && value.length
            && (value.split(locationDelimiter).length === 2)
            && isNumber(value.split(locationDelimiter)[0])
            && isNumber(value.split(locationDelimiter)[1]));
    };

    const getEmailDomain = (email) => {
        const domainRegex = /^[\w+.\w+]*@(\w+\.[\w+.]*)$/g;
        const match = domainRegex.exec(email);

        return match && match[1];
    };

    const removeFromArray = (array, item) => {
        const index = array.findIndex((arrayItem) => arrayItem === item);

        array.splice(index, 1);

        return array;
    };

    const removeDuplicates = (array) => {
        const hash = {};

        return (array || []).reduce((prevArray, item) => {
            if (!hash[item]) {
                hash[item] = true;

                return [
                    ...prevArray,
                    item,
                ];
            }

            return prevArray;
        }, []);
    };

    const isValidEmail = (email = '') => EMAIL_REGEX_VALIDATOR.test(email);

    const getFirstOfList = (list = [], firstItemsCount) => (list.length > firstItemsCount ? (list || []).slice(0, firstItemsCount) : list);

    const joinTokens = (tokens, delimiter) => (tokens || []).reduce((result, currentItem) => {
        if (!result && currentItem) {
            return currentItem;
        }

        if (currentItem) {
            return `${result}${delimiter}${currentItem}`;
        }

        return result;
    }, '');

    const getSearchValuableFieldsSorted = (searchFields) => {
        const extractFieldValues = (field) => (({ selected, minSelected, maxSelected }) => ({ selected, minSelected, maxSelected }))(field);

        const extractValueProperties = ({
            value, group, required, additional,
        }) => ({
            value,
            group: _.chain((group || [])).map(extractValueProperties).sortBy('value').value(),
            required,
            additional,
        });

        const sortAndCleanupSelectedValues = (selectedValues) => selectedValues
            && _.chain(selectedValues)
                .map(extractValueProperties)
                .sortBy((oneValue) => JSON.stringify(oneValue))
                .value();

        return _.chain(searchFields)
            .map(extractFieldValues)
            .map((field) => _.map(field, sortAndCleanupSelectedValues)).value();
    };

    const parseJSON = (string) => {
        try {
            return JSON.parse(string);
        } catch (error) {
            return null;
        }
    };

    // used for adding postfix to cookie keys
    const cookiesOverride = ($cookies) => {
        if ($cookies.overriden) {
            return;
        }
        const cookiePostfix = `_${ENVIRONMENT}`;
        const cookies = { ...$cookies };
        $cookies.get = (key) => cookies.get(`${key}${cookiePostfix}`) || cookies.get(key);
        $cookies.getObject = (key) => cookies.getObject(`${key}${cookiePostfix}`) || cookies.getObject(key);
        $cookies.put = (key, value, options) => cookies.put(`${key}${cookiePostfix}`, value, options);
        $cookies.putObject = (key, value, options) => cookies.putObject(`${key}${cookiePostfix}`, value, options);
        $cookies.remove = (key, options) => cookies.remove(`${key}${cookiePostfix}`, options);
        $cookies.overriden = true;
    };

    return {
        isNumber,
        isWebsite,
        isValidEmail,
        getSearchValuableFieldsSorted,
        isLocationString,
        getEmailDomain,
        removeFromArray,
        removeDuplicates,
        getFirstOfList,
        joinTokens,
        parseJSON,
        cookiesOverride,
    };
}

angular.module('TALENYA-FE').factory('utils', UtilsService);

export default UtilsService();
